import * as _ from "lodash";
import * as angular from "angular";
import { Feature } from "../../models/feature.model";
import { PermissionCheck } from "../../shared/permission";
import { FeatureService } from "../../services/feature.service";

let SignatureSettingsComponent = {
    selector: "vcSignatureSettings",
    templateUrl:
        "/angular/components/signature/signature-settings.component.html",
    bindings: {},
    controller: class SignatureSettingsController {
        private $q: any;
        private featureService: FeatureService;
        public description: string;
        public permissionProvider: PermissionCheck;
        public signature: Feature;
        public emailSummary: Feature;
        public untouchedSignatureDisclaimer: string;
        public untouchedSpecifiedEmail: string;

        constructor(
            $q: any,
            PermissionCheck: PermissionCheck,
            FeatureService: FeatureService
        ) {
            this.$q = $q;
            this.featureService = FeatureService;
            this.permissionProvider = PermissionCheck;

            this.permissionProvider.getConsentSettings().then((settings) => {
                this.signature = new Feature(
                    this.$q,
                    this.featureService,
                    settings.SIGNATURE.attributes
                );
                this.permissionProvider.signatureFeaturePermission =
                    _.cloneDeep(this.signature);
                this.emailSummary = new Feature(
                    this.$q,
                    this.featureService,
                    settings.EMAIL_SUMMARY.attributes
                );
                this.untouchedSignatureDisclaimer = _.cloneDeep(
                    this.signature.extra.disclaimer
                );
                this.untouchedSpecifiedEmail = _.cloneDeep(
                    this.emailSummary.extra.specified_email
                );
            });
        }

        saveSpecifiedEmail() {
            this.emailSummary.update();
            this.permissionProvider.updateValueInSettings(this.emailSummary);
            this.untouchedSpecifiedEmail = _.cloneDeep(
                this.emailSummary.extra.specified_email
            );
        }

        saveSignatureDisclaimer(disclaimer) {
            this.signature.extra.disclaimer = disclaimer;
            this.signature.update();
            this.permissionProvider.updateFeaturePermission(this.signature);
            this.untouchedSignatureDisclaimer = _.cloneDeep(
                this.signature.extra.disclaimer
            );
            this.permissionProvider.signatureFeaturePermission = _.cloneDeep(
                this.signature
            );
        }

        setEnabled(feature, bool) {
            feature.setEnabled(bool);
            this.permissionProvider.updateFeaturePermission(feature);
        }
    },
};

angular
    .module("signature", [])
    .component(SignatureSettingsComponent.selector, SignatureSettingsComponent);
